/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import {
  Button,
  Chip,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  useTheme,
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";

import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useRouteMatch } from "react-router-dom";
import { useForm } from "react-hook-form";
import Authorities from "../../../../auth/authorities";
import withAuthority from "../../../../components/Auth/withAuthority";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import AvailabilitySelection from "../../../../components/time/AvailabilitySelection";
import ConfirmDeleteDialog from "../../components/dialogs/ConfirmDeleteDialog";
import ValidationMessage from "../../../../components/validation/ValidationMessage";
import {
  createDiscountInfo,
  deleteDiscountInfo,
  updateDiscountInfo,
} from "../../../../services/eatprestoApp/discountInfoService";
import {
  combineMinuteOfWeekArrays,
  normalizeTimeSelections,
} from "../../../../utils/time-conversions";
import {
  DISCOUNT_TYPE_AMOUNT,
  ERROR_MESSAGE_CREATING_ERROR,
  ERROR_MESSAGE_DELETING_ERROR,
  ERROR_MESSAGE_NOT_AVAILABLE_DISCOUNT_ERROR,
  ERROR_MESSAGE_UPDATING_ERROR,
  ERROR_MESSAGE_VERSION_ERROR,
  INTEGER_NUMBER_PATTERN,
  NODE_STATUS_CREATE,
  SUCCESSFULLY_CREATED,
  SUCCESSFULLY_DELETED,
  SUCCESSFULLY_UPDATED,
} from "../../../../utils/consts";
import { CustomTheme, Theme } from "../../../../types/customTheme";
import ApplyToSelection from "../../../../components/common/ApplyToSelection";
import { DISCOUNT_TYPE_PERCENT } from "../../../../utils/consts";
import SwitchCommon from "../../../../components/switches/SwitchCommon";
import {
  DeliveryTpe,
  HttpStatus,
  submitButtonName,
} from "../../../../utils/enum";
import ConfirmDeleteDialogDefault from "../../components/dialogs/ConfirmDeleteDialogDefault";
import CardCommon from "../../../../components/card/CardCommon";
import TextfieldCommon from "../../../../components/textField/TextfieldCommon";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import { convertDecimalPoint } from "../../../../utils/ReplaceIcon";
import {
  areObjectArraysEqual,
  cleanObject,
  listsAreEqual,
} from "../../../../utils/isDeepEqual";
import { Autocomplete } from "@material-ui/lab";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";
import { createOfferInfo } from "../../../../services/eatprestoApp/offersService";
import DialogCommon from "../../../../components/dialogs/DialogCommon";
import DialogCommonDefault from "../../../../components/dialogs/DialogCommonDefault";
import TextfieldDefault from "../../../../components/textField/TextfieldDefault";
import FirstTwoTypesGroup from "./FirstTwoTypesGroup";
import PointsModalContent from "./ProductsModal/ProductsModalContent";
import ThirdTypeGroup from "./ThirdTypeGeoup";
import ProductModal from "./ProductsModal";
import OfferModalDialog from "./OfferModalDialog";
import { getLocalStore } from "../../../../utils/store/localStore";
import AlertDialog from "../../../../components/alerts/AlertDialog";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textField: {
      overflowWrap: "break-word",
      wordWrap: "break-word",
    },
    base: {
      padding: "0px 12px 0 12px",
      [theme.breakpoints.up("sm")]: {
        padding: "0px 16px 0 16px",
      },
      borderRadius: 4,
    },
    error: {
      backgroundColor: theme.palette.error.dark,
      borderRadius: "8px 8px 0 0",
      border: `1px solid ${theme.palette.background.entity_border_highlight_background}`,
      padding: 8,
    },
    actionsWrapper: {
      padding: "16px 16px",
      display: "flex",
      justifyContent: "center",
    },
    autoComplete: {
      marginTop: "4px",
      "& .MuiAutocomplete-input": {
        color: theme.palette.custom.orange.contrastText,
      },
      "& .MuiInputBase-root": {
        color: "inherit",
        backgroundColor: theme.palette.background.entity_background,
        borderRadius: 10,
      },
      [`& fieldset`]: {
        borderRadius: 10,
        color: theme.palette.custom.orange.contrastText,
      },
    },
    datePickerStyle: {
      [`& fieldset`]: {
        borderRadius: "10px",
        border: `1px solid ${theme.palette.background.entity_border_highlight_background}`,
        cursor: "pointer",
      },
      "& .MuiPickersClockPointer-pointer": {
        backgroundColor: `${theme.palette.background.default} !important`,
      },
      "& .MuiPickersClockNumber-clockNumberSelected": {
        backgroundColor: `${theme.palette.background.default} !important`,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${theme.palette.background.entity_border_highlight_background}`,
      },
      "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${theme.palette.background.entity_border_highlight_background}`,
      },
    },
    titleColor: {
      color: theme.palette.custom.orange.contrastText,
    },
  }),
);

const offerTypeList = [
  {
    id: "BUY_X_GET_Y_CHEAPEST_DISCOUNTED",
    label: "Buy X Get Y Discounted",
    desc: "Discount the cheapest item(s) when buying multiple predefined items.",
  },
  {
    id: "FIXED_PRICE_FOR_X_ITEMS",
    label: "Fixed Price for X Items",
    desc: "Set a fixed total price when buying a predefined group of items.",
  },
  {
    id: "FIXED_PRICE_FROM_X_LISTS",
    label: "Meal Deal (Pick from Lists)",
    desc: "Offer a fixed price when customers choose one item from each predefined list (e.g. Main, Side, Drink).",
  },
];

const platformList = [
  { id: "kiosk", label: "Kiosk" },
  { id: "online", label: "Online" },
  { id: "phone", label: "Phone" },
  { id: "walk_in", label: "Walk in" },
];

interface FormData {
  name: string;
  description: string;
  usageCount?: number;
  usageDiscountValue: string;
  usageLimit: number;
  discountGroup: string;
  discountCode: string;
  deliveryTypes: [];
  isActive: boolean;
  value: string;
  minOrderPrice: string;
  id?: any;
  locationId?: any;
  discountedQuantity: number;
  discountValue: number;
  fixedTotalPrice: number;
}
export interface DiscountInfoNodeProps {
  openDialog: any;
  setOpenDialog: any;
  nodeData: any;
  getOfferInfo: any;
  offerItemMap: any;
  setOfferItemMap: any;
  offerName: any;
}

/* Create, delete, and update discount information and users can view all discount information. */
const CreateOfferModal: React.FunctionComponent<DiscountInfoNodeProps> = ({
  openDialog,
  setOpenDialog,
  nodeData,
  getOfferInfo,
  offerItemMap,
  setOfferItemMap,
  offerName,
}) => {
  const [deliveryTypesList, setDeliveryTypesList] = useState<any>([
    DeliveryTpe.DINEIN,
    DeliveryTpe.TAKEOUT,
    DeliveryTpe.DELIVERY,
  ]);
  const [deliveryTypesListInitial, setDeliveryTypesListInitial] = useState<any>(
    [DeliveryTpe.DINEIN, DeliveryTpe.TAKEOUT, DeliveryTpe.DELIVERY],
  );
  const [error, setError] = useState("");
  const [selectedWrapperIdList, setSelectedWrapperIdList] = useState<any>({});
  const [selectedWrapperIdListInitial, setSelectedWrapperIdListInitial] =
    useState<any>({});
  const [offerItemMapInitial, setOfferItemMapInitial] = useState<any>({});
  const [groupInfo, setGroupInfo] = useState<any>([]);
  const [isOpenCriticalType, setIsOpenCriticalType] = useState(false);
  const [isOpenPriority, setIsOpenPriority] = useState(false);
  const [isOpenUsageLimitType, setIsOpenUsageLimitType] = useState(false);
  const [isOpenPlatform, setIsOpenPlatform] = useState(false);
  const [isOpenDiscountMethod, setIsOpenDiscountMethod] = useState(false);
  const [isOpenApplyTo, setIsOpenApplyTo] = useState(false);
  const [nodeID, setNodeID] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isAllowRepeatInBasket, setIsAllowRepeatInBasket] = useState(true);

  const [isSwitchActive, setIsSwitchActive] = useState(false);
  const [isActiveInitial, setIsActiveInitial] = useState(true);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [usageCount, setUsageCount] = useState(0);
  const [isDeliveryTypeEmpty, setIsDeliveryTypeEmpty] = useState(false);
  const [isOfferTypeEmpty, setIsOfferTypeEmpty] = useState(false);
  const [usageDiscountValue, setUsageDiscountValue] = useState("0.00");
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [isOpenProductsAddModal, setIsOpenProductsAddModal] = useState(false);
  const [isApplyToEmpty, setIsApplyToEmpty] = useState(false);
  const [isPlatformEmpty, setIsPlatformEmpty] = useState(false);
  const [isMembersEmpty, setIsMembersEmpty] = useState(false);

  const [availabilityErrorMessage, setAvailabilityErrorMessage] =
    useState(false);
  const [success, setSuccess] = useState("");
  const [selectedOfferType, setSelectedOfferType] = useState<any>({});
  const [editableRewardId, setEditableRewardId] = useState<any>([]);
  const [selectedPriorityType, setSelectedPriorityType] = useState<any>([]);
  const [selectedUsageLimitType, setSelectedUsageLimitType] = useState<any>({
    id: "Global",
    label: "GLOBAL",
  });
  const [selectedWrapperIdListInitialNew, setSelectedWrapperIdListInitialNew] =
    useState<any>({});
  const [isOpenSuccessModal, setIsOpenSuccessModal] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState<any>();
  const [selectedDiscountMethod, setSelectedDiscountMethod] = useState<any>({});
  const [isSelectedMethodEmpty, setIsSelectedMethodEmpty] = useState<any>();
  const [finalData, setFinalData] = useState<any>({});
  const [finalBody, setFinalBody] = useState<any>({});
  const [selectedApplyTo, setSelectedApplyTo] = useState<any>({
    id: "CHEAPEST",
    label: "Cheapest",
  });
  const [fromDate, setFromDate] = useState(
    moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  );
  const [toDate, setToDate] = useState(
    moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  );
  const [availabilitySelectionList, setAvailabilitySelectionList] =
    useState<any>([]);
  const [originalNodeData, setOriginalNodeData] = useState({
    availability: [],
    isActive: false,
    minOrderPrice: "0",
    name: "",
    description: "",
    usageLimitType: "",
    usageLimit: 0,
    deliveryTypes: [],
    id: "",
    startAt: null as string | null, // <-- The fix is here
    endAt: null as string | null, // <-- And here
    locationId: "",
    platforms: [],
    offerType: "",
    priority: 50,
    groups: [
      {
        groupIndex: 0,
        name: "",
        requiredPick: 1,
        minPriceEach: null,
        maxPriceEach: null,
        members: [
          {
            memberType: "ITEM",
            memberId: "188",
          },
        ],
      },
    ],
    rewards: [
      {
        rewardType: "",
        discountedQuantity: 1,
        discountMethod: "",
        discountValue: 0,
        applyTo: "",
        allowRepeatInBasket: true,
        fixedTotalPrice: 1,
      },
    ],
  });

  useEffect(() => {
    setSelectedWrapperIdListInitialNew(selectedWrapperIdList);
  }, []);
  const handleSelectProduct = (
    event: Event,
    productWrapper: any,
    item: { id: string; name: string },
  ) => {
    const cloneSelectedWrapperIdList = { ...selectedWrapperIdList };

    // Step 1: Check and remove from undefined section if it exists
    if (cloneSelectedWrapperIdList.undefined?.[item.id]) {
      delete cloneSelectedWrapperIdList.undefined[item.id];

      if (Object.keys(cloneSelectedWrapperIdList.undefined).length === 0) {
        delete cloneSelectedWrapperIdList.undefined;
      }

      const output = Object.entries(offerItemMap).reduce(
        (acc: any, [key, value]: any) => {
          const newObj = { ...value };
          newObj.offerNameList = [...(value.offerNameList || [])];

          // if key equals selected id → increase activeCount by 1 (example logic)
          if (key === item.id) {
            if (isActive) {
              newObj.activeCount = (value.activeCount || 0) - 1;
            } else {
              newObj.deActiveCount = (value.deActiveCount || 0) - 1;
            }
            newObj.offerNameList = newObj.offerNameList.filter(
              (name: string) => name !== offerName,
            );
          }

          acc[key] = newObj;
          return acc;
        },
        {},
      );
      setOfferItemMap(output);
      // Stop here — do not add the item anywhere else
      setSelectedWrapperIdList(cloneSelectedWrapperIdList);
      return;
    }

    // Step 2: Toggle item in the actual productWrapper.id section
    if (cloneSelectedWrapperIdList[productWrapper.id]?.[item.id]) {
      delete cloneSelectedWrapperIdList[productWrapper.id][item.id];
      const output = Object.entries(offerItemMap).reduce(
        (acc: any, [key, value]: any) => {
          const newObj = { ...value };
          newObj.offerNameList = [...(value.offerNameList || [])];

          // if key equals selected id → increase activeCount by 1 (example logic)
          if (key === item.id) {
            if (isActive) {
              newObj.activeCount = (value.activeCount || 0) - 1;
            } else {
              newObj.deActiveCount = (value.deActiveCount || 0) - 1;
            }
            newObj.offerNameList = newObj.offerNameList.filter(
              (name: string) => name !== offerName,
            );
          }

          acc[key] = newObj;
          return acc;
        },
        {},
      );
      setOfferItemMap(output);
      if (
        Object.keys(cloneSelectedWrapperIdList[productWrapper.id]).length === 0
      ) {
        delete cloneSelectedWrapperIdList[productWrapper.id];
      }
    } else {
      if (!cloneSelectedWrapperIdList[productWrapper.id]) {
        cloneSelectedWrapperIdList[productWrapper.id] = {};
      }
      const output = Object.entries(offerItemMap).reduce(
        (acc: any, [key, value]: any) => {
          const newObj = { ...value };

          // Ensure offerNameList exists
          newObj.offerNameList = [...(value.offerNameList || [])];

          if (key === String(item.id)) {
            if (isActive) {
              // 🔵 When activating: increase activeCount and add offer name
              newObj.activeCount = (value.activeCount || 0) + 1;
            } else {
              // 🔴 When deactivating: increase deActiveCount and remove offer name if exists
              newObj.deActiveCount = (value.deActiveCount || 0) + 1;

              newObj.offerNameList = newObj.offerNameList.filter(
                (name: string) => name !== offerName,
              );
            }

            if (!newObj.offerNameList.includes(offerName)) {
              newObj.offerNameList.push(offerName);
            }
          }

          acc[key] = newObj;
          return acc;
        },
        {},
      );

      setOfferItemMap(output);

      cloneSelectedWrapperIdList[productWrapper.id][item.id] = {
        memberId: item.id,
        wrapperId: productWrapper.id,
        name: item.name,
        img: productWrapper.img,
        memberType: "ITEM",
      };
    }

    setSelectedWrapperIdList(cloneSelectedWrapperIdList);
  };

  /* Use a react form hooks */
  const { register, handleSubmit, errors, reset, formState, clearErrors } =
    useForm<FormData>({
      defaultValues: {
        name: "",
        description: "",
        value: "",
        minOrderPrice: "",
        usageLimit: 0,
        discountGroup: "",
        deliveryTypes: [],
        discountCode: "",
        discountedQuantity: 1,
      },
    });

  // Check the form edit or not using react form hook.
  const isFormEdited = formState.isDirty;

  const match: any = useRouteMatch();

  /* Get updated data after changes. */
  const getNodeDataByState = (data: any) => {
    const updatedData = _.cloneDeep(originalNodeData);
    const abc: any = [];
    selectedPlatform.forEach((item: any) => {
      abc.push(item.id);
    });
    updatedData.availability = availabilitySelectionList;
    updatedData.isActive = isActive;
    updatedData.minOrderPrice = convertDecimalPoint(
      data.minOrderPrice,
    ).toString();
    updatedData.offerType = selectedOfferType.id;
    updatedData.priority = selectedPriorityType.id;
    updatedData.platforms = abc;
    updatedData.name = data.name;
    updatedData.description = data.description;
    updatedData.startAt = isSwitchActive ? fromDate.replace(" ", "T") : null;
    updatedData.endAt = isSwitchActive ? toDate.replace(" ", "T") : null;
    updatedData.deliveryTypes = deliveryTypesList;
    updatedData.usageLimitType = "GLOBAL";
    updatedData.usageLimit = 0;
    // updatedData.groups = data.requiredPick;

    if (
      selectedOfferType.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" ||
      selectedOfferType.id === "FIXED_PRICE_FOR_X_ITEMS"
    ) {
      const selectedProductsUpdate = Object.values(
        selectedWrapperIdList,
      ).flatMap((innerObj: any) =>
        Object.values(innerObj).map(({ memberType, memberId }: any) => ({
          memberType,
          memberId: Number(memberId),
        })),
      );
      const obj: any = {
        groupIndex: 0,
        name: data.name,
        requiredPick: data.requiredPick,
        minPriceEach: null,
        maxPriceEach: null,
        members: selectedProductsUpdate,
      };

      updatedData.groups = [obj];
    } else {
      groupInfo.map((group: any) => {
        group.members.map((item: any) => {
          delete item.menuId;
        });
      });
      updatedData.groups = groupInfo;
    }
    let rewards: any = {};

    if (selectedOfferType.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED") {
      rewards["rewardType"] = "DISCOUNT_CHEAPEST_ITEMS";
      rewards["discountMethod"] = selectedDiscountMethod?.id;
      rewards["discountValue"] =
        selectedDiscountMethod.id === "FREE" ? 0 : data.discountValue;
      rewards["fixedTotalPrice"] = 0;
    } else {
      rewards["rewardType"] = "FIXED_PRICE_BUNDLE";
      rewards["discountMethod"] = "FIXED";
      rewards["discountValue"] = 0;
      rewards["fixedTotalPrice"] = data.fixedTotalPrice;
    }
    rewards["discountedQuantity"] = data.discountedQuantity;
    rewards["applyTo"] = selectedApplyTo?.id;
    rewards["allowRepeatInBasket"] = isAllowRepeatInBasket;
    updatedData.rewards = [rewards];
    return updatedData;
  };
  /* Update states after creating delete or update banner information. */
  const setNodeDataToState = useCallback((nodeValues) => {
    const {
      id,
      isActive,
      minOrderPrice,
      name,
      description,
      value,
      usageLimit,
      discountGroup,
      discountCode,
      deliveryTypes,
      offerType,
      priority,
      startAt,
      endAt,
      platforms,
    } = nodeValues;
    setNodeID(id);
    setUsageCount(usageCount);
    setUsageDiscountValue(usageDiscountValue);
    offerTypeList.map((item: any) => {
      if (item.id === offerType) {
        setSelectedOfferType({ id: item.id, label: item.label });
      }
    });
    const platform: any = [];

    platformList.map((item: any) => {
      if (platforms.includes(item.id)) {
        platform.push({ id: item.id, label: item.label });
      }
    });

    setSelectedPlatform(platform);
    setFromDate(
      startAt
        ? startAt.replace("T", " ")
        : moment().format("YYYY-MM-DD HH:mm:ss"),
    );
    setToDate(
      endAt ? endAt.replace("T", " ") : moment().format("YYYY-MM-DD HH:mm:ss"),
    );
    setSelectedPriorityType({ id: priority, label: priority.toString() });
    // setIsActive(isActive);
    setIsActiveInitial(isActive);

    // Changing the value of the text field according to the response.
    reset({
      name,
      description,
      value,
      minOrderPrice,
      usageLimit: usageLimit.toString(),
      discountGroup,
      deliveryTypes,
      discountCode,
    });
  }, []);

  useEffect(() => {
    setOfferItemMapInitial(offerItemMap);
  }, []);
  useEffect(() => {
    setOriginalNodeData(nodeData);
    setNodeDataToState(nodeData);
  }, [nodeData, setNodeDataToState]);

  /* Enable or disable Create/Edit button. */
  useEffect(() => {
    // Enables the create/edit button if any changes are not made to the form.
    if (
      !isFormEdited &&
      isActive === isActiveInitial &&
      listsAreEqual(deliveryTypesList, deliveryTypesListInitial)
    ) {
      setButtonDisabled(true);
    } else {
      // Enables the create/edit button if any changes are made to the form.
      setButtonDisabled(false);
    }
  }, [
    isFormEdited,
    isActive,
    isActiveInitial,
    deliveryTypesList,
    deliveryTypesListInitial,
  ]);

  /* Update the deliveryTypeList after selecting the delivery options using switches (dine-in, takeout, and delivery). */
  const handleSelectDeliveryTypes = (e: any) => {
    const { value, name, checked } = e.target;
    setIsDeliveryTypeEmpty(false);
    // When a delivery type option is selected, that delivery type option is entered into a list.
    if (checked) {
      const selectedList: any = new Set([...deliveryTypesList, value]);
      setDeliveryTypesList([...selectedList]);
    } else {
      // When a delivery type option is not selected, that delivery type option is removed into a list.
      const selectedList: any = deliveryTypesList.filter(
        (amountType: String) => name !== amountType,
      );
      setDeliveryTypesList(selectedList);
    }
  };

  /* Send an API call to crete discount information after click create button. */
  const handleCreateOfferOption = async (data: any) => {
    setError("");
    const createData: any = getNodeDataByState(data);
    delete createData.status;
    let message = "";

    message = "Eatpresto Discount Information Changed";

    const summary = {
      Active: data.active ? "Active" : "Inactive",
      "Discount Group": data.discountGroup,
      "Min Order Price": data.minOrderPrice,
      Name: data.name,
      Description: data.description,
      "usage Limit": data.usageLimit,
      "Payment Types": data.paymentTypes,
    };
    const body = {
      message,
      summary: `Discount Information changed from ${JSON.stringify(
        [],
      )} to ${JSON.stringify([cleanObject(summary)])}`,
      code: "create",
      access_type: true,
      metadata: { changedBy: "" },
    };
    setIsOpenSuccessModal(true);
    setFinalData(createData);
    setFinalBody(body);
  };

  /* Check for a create or update and 
  call the handleCreateOfferOption function if it is a create and 
  handleUpdateDiscountInfo function if it is a update. */
  const handleSubmitData = handleSubmit((data) => {
    setError("");

    // 1. Reset all previous validation errors at the start of the submission.
    setIsDeliveryTypeEmpty(false);
    setIsOfferTypeEmpty(false);
    setIsSelectedMethodEmpty(false);
    setIsApplyToEmpty(false);
    setIsPlatformEmpty(false);
    setIsMembersEmpty(false);
    // 2. Use a flag to track if the form is valid.
    let isFormValid = true;

    // --- Validation Checks ---
    // Check for Delivery Types
    if (_.isEmpty(deliveryTypesList)) {
      setIsDeliveryTypeEmpty(true);
      isFormValid = false;
    }
    // Check for Offer Type
    if (!selectedOfferType?.id) {
      setIsOfferTypeEmpty(true);
      isFormValid = false;
    }
    // Check for "Apply To"
    if (
      !selectedApplyTo?.id &&
      selectedOfferType?.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED"
    ) {
      setIsApplyToEmpty(true);
      isFormValid = false;
    }
    if (selectedPlatform.length === 0) {
      setIsPlatformEmpty(true);
      isFormValid = false;
    }
    if (
      selectedOfferType?.id !== "FIXED_PRICE_FROM_X_LISTS" &&
      Object.keys(selectedWrapperIdList).length === 0
    ) {
      setIsMembersEmpty(true);
      isFormValid = false;
    }
    if (
      selectedOfferType?.id === "FIXED_PRICE_FROM_X_LISTS" &&
      Object.keys(groupInfo).length < 2
    ) {
      setIsMembersEmpty(true);
      isFormValid = false;
    }
    // Conditionally check for Discount Method only if the offer type requires it
    if (
      selectedOfferType?.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" &&
      !selectedDiscountMethod?.id
    ) {
      setIsSelectedMethodEmpty(true);
      isFormValid = false;
    }
    // 3. If after all checks the form is still valid, proceed with submission.
    if (!isFormValid) {
      return; // Stop the submission if any validation failed
    }
    // --- Submission Logic ---
    setAvailabilityErrorMessage(false); // Clear other potential errors

    handleCreateOfferOption(data);
  });

  /* Send an API call to after click availability apply button. 
  An API call is sent only if the status is not "create". */
  const handleSubmitAvailability = async (
    availabilitySelectionList: Array<any>,
  ) => {
    const combinedMowArrays: any = combineMinuteOfWeekArrays(
      availabilitySelectionList,
    );
    let normalizedArray = _.cloneDeep(combinedMowArrays);

    // Remove select same date range in same same date.
    Object.keys(combinedMowArrays).forEach((day) => {
      normalizedArray[day] = normalizeTimeSelections(normalizedArray[day]);
    });

    // Convert array to minute of week array
    const mowArray: any = Object.values(normalizedArray).flat();

    // Update data
    setAvailabilitySelectionList(mowArray);
  };

  const updateOfferStatus = (checked: boolean) => {
    const output: any = {};

    Object.entries(offerItemMap).forEach(([key, value]: any) => {
      // copy old data
      output[key] = { ...value };
      // check if this idList includes the offer
      if (value.idList.includes(nodeData.id)) {
        if (checked) {
          // ✅ activating: decrease deActive, increase active
          output[key].activeCount = Math.min(
            value.activeCount + 1,
            value.idList.length,
          );
          output[key].deActiveCount = Math.max(value.deActiveCount - 1, 0);
        } else {
          // ❌ deactivating: decrease active, increase deActive
          output[key].activeCount = Math.max(value.activeCount - 1, 0);
          output[key].deActiveCount = value.deActiveCount + 1;
        }
      }
    });

    return output;
  };

  /* Active switch status change using switch */
  const handleSwitchActivate = (e: any) => {
    const { checked } = e.target;
    setIsActive(checked);

    const updatedOfferItemMap = updateOfferStatus(checked);
    setOfferItemMap(updatedOfferItemMap);
  };

  const handleAllowRepeatInBasketActivate = (e: any) => {
    const { checked } = e.target;
    setIsAllowRepeatInBasket(checked);
  };

  const handleSelectSwitchActivate = (e: any) => {
    const { checked } = e.target;
    setIsSwitchActive(checked);
  };

  const handleChangeOfferType = (e: any, offerType: any) => {
    if (offerType.id !== "BUY_X_GET_Y_CHEAPEST_DISCOUNTED") {
      setSelectedDiscountMethod({ id: "FIXED", label: "Fixed" });
    }
    if (offerType?.id === "FIXED_PRICE_FOR_X_ITEMS") {
      handleChangeApplyTo(null, { id: "CHEAPEST", label: "Cheapest" });
    }
    setIsOfferTypeEmpty(false);
    setSelectedOfferType(offerType);
    setSelectedApplyTo({
    id: "CHEAPEST",
    label: "Cheapest",
  });
    setSelectedDiscountMethod({});
  };

  const handleChangePriorityType = (e: any, priorityType: any) => {
    setSelectedPriorityType(priorityType);
  };

  const handleChangeUsageLimitType = (e: any, priorityType: any) => {
    setSelectedPriorityType(priorityType);
  };

  const handleChangePlatform = (e: any, applyTo: any) => {
    setSelectedPlatform(applyTo);
  };

  const handleChangeDiscountMethod = (e: any, discountMethod: any) => {
    setSelectedDiscountMethod(discountMethod);
    setIsSelectedMethodEmpty(false);

    clearErrors("discountValue");
  };

  const handleChangeApplyTo = (e: any, priorityType: any) => {
    setSelectedApplyTo(priorityType);
  };

  const handleChangeFromDate = (date: any) => {
    setFromDate(moment(date).format("YYYY-MM-DD HH:mm:ss"));
  };

  const handleChangeToDate = (date: any) => {
    setToDate(moment(date).format("YYYY-MM-DD HH:mm:ss"));
  };

  const handleOpenProductsAddModal = () => {
    setIsOpenProductsAddModal(true);
  };

  const handleSubmitRewards = () => {
    setIsMembersEmpty(false);
    setIsOpenProductsAddModal(false);
  };

  const handleCloseSuccessModal = async () => {
    // Set 'isOpenSuccessModal' state to false to hide the success modal.
    await createOfferInfo(
      match.params.locationId,
      finalData,
      finalBody,
      "eatpresto",
    )
      .then((res) => {
        getOfferInfo();
        setSuccess(SUCCESSFULLY_CREATED);
        setOpenDialog(false);
        setIsOpenSuccessModal(true);
      })
      .catch((err) => {
        if (err.response.status === HttpStatus.CONFLICT_409) {
          setError(ERROR_MESSAGE_VERSION_ERROR);
          getOfferInfo();
        } else {
          setError(ERROR_MESSAGE_CREATING_ERROR);
        }
      });
    setIsOpenSuccessModal(false);
  };
  return (
    <>
      <DialogCommonDefault
        open={openDialog}
        setOpen={() => setOpenDialog(false)}
        isNeedFixedHeight={false}
      >
        <DialogTitle>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h5">Create Offers</Typography>
            <Button onClick={() => setOpenDialog(false)}>
              <CloseIcon />
            </Button>
          </div>
        </DialogTitle>
        <DialogContent>
          <OfferModalDialog
            register={register}
            errors={errors}
            handleOpenProductsAddModal={handleOpenProductsAddModal}
            selectedWrapperIdList={selectedWrapperIdList}
            isMembersEmpty={isMembersEmpty}
            deliveryTypesList={deliveryTypesList}
            success={success}
            setSuccess={setSuccess}
            error={error}
            isActive={isActive}
            handleSwitchActivate={handleSwitchActivate}
            handleSelectDeliveryTypes={handleSelectDeliveryTypes}
            isDeliveryTypeEmpty={isDeliveryTypeEmpty}
            isOpenCriticalType={isOpenCriticalType}
            setIsOpenCriticalType={setIsOpenCriticalType}
            offerTypeList={offerTypeList}
            selectedOfferType={selectedOfferType}
            handleChangeOfferType={handleChangeOfferType}
            isOfferTypeEmpty={isOfferTypeEmpty}
            isPlatformEmpty={isPlatformEmpty}
            isApplyToEmpty={isApplyToEmpty}
            isOpenPriority={isOpenPriority}
            setIsOpenPriority={setIsOpenPriority}
            isOpenUsageLimitType={isOpenUsageLimitType}
            setIsOpenUsageLimitType={setIsOpenUsageLimitType}
            isOpenPlatform={isOpenPlatform}
            setIsOpenPlatform={setIsOpenPlatform}
            isOpenDiscountMethod={isOpenDiscountMethod}
            setIsOpenDiscountMethod={setIsOpenDiscountMethod}
            isOpenApplyTo={isOpenApplyTo}
            setIsOpenApplyTo={setIsOpenApplyTo}
            selectedPriorityType={selectedPriorityType}
            selectedUsageLimitType={selectedUsageLimitType}
            selectedPlatform={selectedPlatform}
            selectedDiscountMethod={selectedDiscountMethod}
            selectedApplyTo={selectedApplyTo}
            handleChangePriorityType={handleChangePriorityType}
            handleChangeUsageLimitType={handleChangeUsageLimitType}
            platformList={platformList}
            handleChangePlatform={handleChangePlatform}
            availabilitySelectionList={availabilitySelectionList}
            handleChangeDiscountMethod={handleChangeDiscountMethod}
            handleChangeApplyTo={handleChangeApplyTo}
            handleSubmitAvailability={handleSubmitAvailability}
            setAvailabilityErrorMessage={setAvailabilityErrorMessage}
            availabilityErrorMessage={availabilityErrorMessage}
            isSwitchActive={isSwitchActive}
            handleSelectSwitchActivate={handleSelectSwitchActivate}
            fromDate={fromDate}
            toDate={toDate}
            handleChangeFromDate={handleChangeFromDate}
            handleChangeToDate={handleChangeToDate}
            isSelectedMethodEmpty={isSelectedMethodEmpty}
            isAllowRepeatInBasket={isAllowRepeatInBasket}
            handleAllowRepeatInBasketActivate={
              handleAllowRepeatInBasketActivate
            }
            setGroupInfo={setGroupInfo}
            groupInfo={groupInfo}
            isLoadingButton={isLoadingButton}
            setOpenDialog={setOpenDialog}
            handleSubmitData={handleSubmitData}
            offerItemMap={offerItemMap}
            setOfferItemMap={setOfferItemMap}
            offerItemMapInitial={offerItemMapInitial}
            selectedWrapperIdListInitialNew={selectedWrapperIdListInitialNew}
            offerName={offerName}
          />
        </DialogContent>
      </DialogCommonDefault>
      <ProductModal
        isOpen={isOpenProductsAddModal}
        setIsOpen={setIsOpenProductsAddModal}
        selectedWrapperIdList={selectedWrapperIdList}
        handleSubmitRewardsTypePoints={handleSubmitRewards}
        isEdit={false}
        rewardId={editableRewardId}
        isLoadingButton={isLoadingButton}
        handleSelectProduct={handleSelectProduct}
        setSelectedWrapperIdList={setSelectedWrapperIdList}
        selectedWrapperIdListInitial={selectedWrapperIdListInitial}
        offerItemMap={offerItemMap}
        selectedWrapperIdListInitialNew={{}}
        setOfferItemMap={setOfferItemMap}
        offerItemMapInitial={offerItemMapInitial}
      />
      <AlertDialog
        open={isOpenSuccessModal}
        confirmAction={handleCloseSuccessModal}
        title="Confirm Offer Creation"
        desc={"Are you sure you want to create this new offer?"}
        severity="warning"
        confirmLabel="Ok"
        cancelAction={() => setIsOpenSuccessModal(false)}
        cancelLabel={"cancel"}
        disableBackdropClick
        color={"secondary"}
      />
    </>
  );
};

export default CreateOfferModal;
